import { Container } from "@mui/material";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";

const PrivacyPolicy = () => {
  return (
    <>
      <section className="terms-conditions">
        <Container>
          <div className="terms-content">
            <div className="section-title">
              <h2 className="text-center">Privacy Policy</h2>
              <p>Last updated on [21/07/2025] </p>
              <p>
                This Privacy Policy (“Policy”) describes the policies and
                procedures of the collection, use, disclosure and protection of
                your information when you use our website located at
                ___https://packpro.swiggy.com/__ (“Platform”) made available by
                Swiggy Limited (“Company”, “we”, “us” and “our”), a company
                established under the laws of India having its registered office
                at No.55 Sy No.8-14, Ground Floor, I&J Block, Embassy Tech
                Village, Outer Ring Road, Devarbisanahalli, Bengaluru – 560103.
              </p>
              <p>This Policy is published in compliance with, inter alia:</p>
              <ul style={{ listStyle: "auto" }}>
                <li>
                  Section 43A of the Information Technology Act, 2000 (“IT
                  Act”);
                </li>
                <li>
                  Rule 4 of the Information Technology (Reasonable Security
                  Practices and Procedures and Sensitive Personal Information)
                  Rules, 2011 (“SPDI Rules”); and
                </li>
                <li>
                  Regulation 3(1) of the Information Technology (Intermediary
                  Guidelines and Digital Media Ethics Code) Rules, 2021
                  (“Intermediary Guidelines”).
                </li>
              </ul>
              <p>
                The terms “you”, “your” and “User(s)” refer to the user of the
                Platform. The term “Services” refers to facilitation services
                which helps Users to explore a variety of Merchants (as defined
                below) and term “Services” shall refer to any services offered
                by Company whether on the Platform or otherwise.
              </p>
              <p>
                The Platform also allows Users to discover and connect with
                merchants (“Merchants”) who are independent packaging material
                suppliers for variety of restaurants.
              </p>
              <p>
                Please read this Policy before using the Platform or submitting
                any personal information to Company. This Policy is a part of
                and incorporated within, and is to be read along with, the Terms
                of Use (“Terms”). For the purposes of this Policy, unless
                defined hereunder, all capitalized terms shall have the meaning
                ascribed to them in the Terms. By using the Platform, or the
                Services, you confirm that you have read, understood, and agree
                with the privacy practices described in this Policy, and the
                Terms and the collection, storage and processing of your
                information in accordance with them.
              </p>
              <h3>GENERAL TERM ON ACCESS</h3>
              <p>
                By accessing or using the Platform, or the Services, or by
                otherwise giving us your information, you confirm that you have
                the capacity to enter into a legally binding contract under the
                Indian Contract Act, 1872, and have read, understood, and agree
                with the privacy practices described in this Policy, and the
                collection, storage and processing of your information in
                accordance with them. Please go through this Policy in detail
                and contact us if you have any questions or require any
                clarifications.
              </p>
              <p>
                If you are under 18 years of age, then please do not use or
                access the Service(s) at any time or in any manner. If you are a
                parent or guardian and discover that your child under 18 years
                of age has obtained an account on or otherwise accessed the
                Service, then you may alert us at support@Company.co.in
              </p>
              <p>
                As a Merchant, you agree to comply with this obligation, and to
                otherwise comply with any data correction, erasure, deletion or
                other similar obligations.
              </p>
              <p>
                As a Merchant, you undertake not to collect (or otherwise cause
                or permit the collection of) any data relating to children to
                honour any access, correction, deletion or disclosure
                requirements promptly and efficaciously, and in an event, no
                later than is required under applicable law.
              </p>
              <h3>YOUR CONSENT</h3>
              <p>
                By using the Platform and the Services, you agree and consent to
                the collection, transfer, use, storage, disclosure and sharing
                of your information as described and collected by us in
                accordance with this Policy. If you do not agree with the
                Policy, please do not use or access the Platform. If you are
                accessing or using Services or the Platform from an overseas
                location, you do so at your own risk, and shall be solely liable
                for compliance with any applicable local laws.
              </p>
              <p>
                As a Merchant, you undertake to comply with applicable law and
                notify Customers and obtain their consent for collection, use
                and further sharing of their personal data by you as the
                Merchant.
              </p>
              <h3>POLICY CHANGES</h3>
              <p>
                We may occasionally update this Policy and the updated Policy
                will be posted on this page. If we make any significant changes
                to this Policy we will endeavor to intimate you of such changes,
                such as via prominent notice on the Platform or to your email
                address on record and where required by applicable law, we will
                obtain your consent. To the extent permitted under the
                applicable law, your continued use of the Services following the
                changes to this Privacy Policy will constitute your consent and
                acceptance of those changes.
              </p>
              <h3>LINKS TO OTHER WEBSITES</h3>
              <p>
                The Platform may contain links to other websites and similar
                other features. Your use of such websites and/or features may
                result in the collection, processing or sharing of information
                about you, depending on the website/feature. Any personal
                information about you collected whilst visiting such
                websites/feature is not governed by this Policy, unless
                specifically mentioned otherwise. Swiggy shall not be
                responsible for and has no control over the practices and
                content of any website/feature accessed using such links
                contained on the Platform. This Policy shall not apply to any
                information you may disclose to any of our service
                providers/service personnel which we do not require you to
                disclose to us or any of our service providers under this
                Policy. We strongly encourage you to read such third parties'
                privacy policies.
              </p>
              <p>
                You further acknowledge and agree that we are not liable for any
                loss or damage which may be incurred by you as a result of the
                collection and/or disclosure of your information by the
                Merchants, partners or via third party websites, as a result of
                any reliance placed by you on the completeness, accuracy or
                existence of any advertising, services, or other materials on,
                or available via such third party links. This will include all
                transactions, and information transmitted therein, between you
                and any such third-party sites or applications or resources,
                such transactions are strictly bi-partite. We shall not be
                liable for any disputes arising from or in connection with such
                transactions between you and the aforementioned third parties.
              </p>
              <h3>INFORMATION WE COLLECT FROM YOU</h3>
              <ul>
                <li>
                  <p>
                    <strong>Your Device Information:</strong> In order to
                    improve your app experience and lend stability to our
                    Services to you, we may collect information or employ third
                    party plugins that collect information about the devices you
                    use to access our Services, including the hardware models,
                    operating systems and versions, software, file names and
                    versions, preferred languages, device identifiers,
                    advertising identifiers, device motion information, mobile
                    network information, installed applications on device and
                    phone state. The information collected thus will be
                    disclosed to or collected directly by these plugins and may
                    be used to improve the content and/or functionality of the
                    services offered to you. Analytics companies may use mobile
                    device IDs to track your usage of the Platform.
                  </p>
                </li>
                <li>
                  <p>
                    <strong>Usage information:</strong> Details of your use of
                    our Services, including but not limited to traffic data,
                    location data, logs and other communication data and the
                    resources that you access and use on or through our
                    Services.
                  </p>
                </li>
                <li>
                  <p>
                    <strong>Your account information:</strong> Your full name,
                    email address, postal code, password and other information
                    you may provide with your account, such as your mobile phone
                    number. For few Services we may also collect your profile
                    picture. You may optionally provide us with this information
                    through third-party sign-in services. In such cases, we
                    fetch and store whatever information is made available to us
                    by you through these sign-in services.
                  </p>
                </li>
                <li>
                  <p>
                    <strong>Collection of personal information</strong> - Some
                    of the Services require us to know who you are so that we
                    can best meet your needs. When you access the Services, or
                    through any interaction with us via emails, telephone calls
                    or other correspondence, we may ask you to voluntarily
                    provide us with certain information that personally
                    identifies you or could be used to personally identify you.
                    You hereby consent to the collection of such information by
                    Company. Without prejudice to the generality of the above,
                    information collected by us from you may include (but is not
                    limited to) the following:
                  </p>{" "}
                  <ul style={{ listStyle: "lower-roman" }}>
                    <li>
                      contact data (such as your email address and phone
                      number);
                    </li>
                    <li>
                      demographic data (such as your gender, your date of birth
                      and your pin code);
                    </li>
                    <li>
                      data regarding your usage of the services and history of
                      the appointments made by or with you through the use of
                      Services;
                    </li>
                    <li>
                      other information that you voluntarily choose to provide
                      to us (such as information shared by you with us through
                      emails or letters) including any images and other
                      documents/files;
                    </li>
                    <li>
                      data shared by the Merchants pertaining to the Services
                      availed by you.
                    </li>
                  </ul>
                </li>
              </ul>

              <p>
                The information collected from you by Company may constitute
                ‘personal information’ or ‘sensitive personal data or
                information’ under the SPI Rules.
              </p>

              <p>
                <strong>“Personal Information”</strong> is defined under the SPI
                Rules to mean any information that relates to a natural person,
                which, either directly or indirectly, in combination with other
                information available or likely to be available to a body
                corporate, is capable of identifying such person.
              </p>

              <p>
                The SPI Rules further define
                <strong>“Sensitive Personal Data or Information”</strong> of a
                person to mean personal information about that person relating
                to:
              </p>

              <ul style={{ listStyle: "lower-roman" }}>
                <li>passwords;</li>
                <li>
                  financial information such as bank accounts, credit and debit
                  card details or other payment instrument details;
                </li>
                <li>physical, physiological and mental health condition;</li>
                <li>sexual orientation;</li>
                <li>medical records and history;</li>
                <li>biometric information;</li>
                <li>
                  information received by body corporate under lawful contract
                  or otherwise;
                </li>
                <li>
                  visitor details as provided at the time of registration or
                  thereafter; and
                </li>
                <li>call data records.</li>
              </ul>

              <p>
                Company will be free to use, collect and disclose information
                that is freely available in the public domain without your
                consent.
              </p>
              <ul>
                <li>
                  <strong>Your preferences:</strong> Your preferences and
                  settings such as time zone and language. The search terms you
                  have looked up and results you selected.
                </li>

                <li>
                  How long you used our Services and which features you used,
                  the ads you clicked on.
                </li>

                <li>
                  <strong>Your content:</strong> Information you provide through
                  our Services, including your ratings and/or reviews of our
                  Merchants and/or their services, current and prior appointment
                  details, and history, most ordered service etc. and other
                  information you provide to us.
                </li>

                <li>
                  <strong>Your communications:</strong> Communications between
                  you and other users, service providers, Merchants, through our
                  Services; your participation in a survey, poll, campaign,
                  contest or promotion scheme; your request for certain features
                  (e.g., newsletters, updates or other products); your
                  communication with us about employment and/or
                  occupational/professional opportunities.
                </li>

                <li>
                  <strong>Your transactional information:</strong> If you make
                  reservations or purchases through our Services, we may collect
                  and store information about you to process your requests and
                  automatically complete forms for future transactions,
                  including (but not limited to) your phone number, address,
                  email, billing information in a tokenized manner.
                </li>

                <li>
                  <strong>Your Public Posts:</strong> You also may provide
                  information (such as ratings, reviews, comments, likes) to be
                  published or displayed (hereinafter, "posted") on certain
                  areas of our Services (collectively, "User Content"). Your
                  User Content are posted on and transmitted to others at your
                  own risk. Additionally, we cannot control the actions of other
                  users of our Services with whom you may choose to share your
                  User Content. We may display this information on the Services,
                  share it with businesses, and further distribute it to a wider
                  audience through third party sites and services. You should be
                  careful about revealing any sensitive details about yourself
                  in such postings.
                </li>

                <li>
                  <strong>
                    Information We Collect Through Automatic Data Collection
                    Technologies:
                  </strong>
                  We may automatically collect certain information about the
                  computer or devices (including mobile devices) you use to
                  access the Services, and about your use of the Services, even
                  if you use the Services without registering or logging in.
                </li>

                <li>
                  <strong>Stored information and files:</strong> Our
                  applications also may access metadata and other information
                  associated with other files stored on your mobile device with
                  your consent.
                </li>

                <li>
                  <strong>Location information:</strong> Our applications
                  collect real-time information about the location of your
                  device, as permitted by you.
                </li>

                <li>
                  <strong>Last URL visited:</strong> The URL of the last web
                  page you visited before visiting our websites.
                </li>

                <li>
                  <strong>Applications:</strong> If you use the application,
                  Swiggy may collect information about the presence and/ or
                  absence and/ or details pertaining to other applications on
                  your mobile phone.
                </li>

                <li>
                  We use the information you provide to us to enhance the
                  functionality and improve the quality of our Services, and to
                  personalize your experience while using our Services. We also
                  use this Our Platform and third parties with whom we partner,
                  may use cookies, pixel tags, web beacons, mobile information
                  to display relevant advertising, provide support to you,
                  communicate with you, and comply with our legal obligations.
                </li>

                <li>
                  device IDs, “flash cookies (wherever applicable)” and similar
                  files or technologies to collect and store information with
                  respect to your use of the Services and third-party websites.
                </li>
              </ul>
              <h3>COOKIES</h3>
              <p>
                Cookies are small files that are stored on your browser or
                device by websites, apps, online media
              </p>
              <p>
                and advertisements. We use cookies and similar technologies for
                purposes such as:
              </p>
              <ul>
                <li>Authenticating users;</li>
                <li>Remembering user preferences and settings;</li>
                <li>Determining the popularity of content;</li>
                <li>
                  Delivering and measuring the effectiveness of advertising
                  campaigns;
                </li>
                <li>
                  Analysing site traffic and trends, and generally understanding
                  the online behaviours and interests of people who interact
                  with our services.
                </li>
              </ul>
              <p>
                A pixel tag (also called a web beacon or clear GIF) is a tiny
                graphic with a unique identifier, embedded invisibly on a
                webpage (or an online ad or email), and is used to count or
                track things like activity on a webpage or ad impressions or
                clicks, as well as to access cookies stored on users’ computers.
                We use pixel tags to measure the popularity of our various
                pages, features and services. We also may include web beacons in
                e-mail messages or newsletters to determine whether the message
                has been opened and for other analytics.
              </p>
              <p>
                To modify your cookie settings, please visit your browser’s
                settings. By using our Services with your browser settings to
                accept cookies, you are explicitly consenting to our use of
                cookies in the manner described in this section.
              </p>
              <p>
                We may also allow third parties to provide audience measurement
                and analytics services for us, to serve advertisements on our
                behalf across the Internet, and to track and report on the
                performance of those advertisements. These entities may use
                cookies, web beacons, SDKs and other technologies to identify
                your device when you visit the Platform and use our Services, as
                well as when you visit other online sites and services.
              </p>
              <h3>USES OF YOUR INFORMATION</h3>
              <p>
                We use the information we collect for following purposes,
                including:
              </p>
              <ul>
                <li>
                  To provide, personalise, maintain and improve our services,
                  enable features to personalise your account;
                </li>
                <li>
                  To carry out our obligations arising from any contracts
                  entered into between you and us and to provide you with the
                  relevant information and services;
                </li>
                <li>
                  To share with the Merchants for fulfilment of your query
                  regarding Merchant services/ products;
                </li>
                <li>
                  To administer and enhance the security of our Platform and for
                  internal operations, including troubleshooting, data analysis,
                  testing, research, statistical and survey purposes;
                </li>
                <li>
                  To provide you with information about services we consider
                  similar to those that you are already using, or have enquired
                  about, or may interest you. If you are a registered user, we
                  will contact you by electronic means (e-mail or SMS or
                  telephone or other internet based instant messaging systems)
                  with information about these services;
                </li>
                <li>
                  To understand our users (what they do on our Services, what
                  features they like, how they use them, etc.), improve the
                  content and features of our Services (such as by personalizing
                  content to your interests), process and complete your
                  transactions, make special offers provide customer support,
                  process and respond to your queries;
                </li>
                <li>
                  To generate and review reports and data about, and to conduct
                  research on, our user base and Service usage patterns and
                  share it with third parties;
                </li>
                <li>
                  To allow you to participate in interactive features of our
                  Services, if any; or
                </li>
                <li>
                  To measure or understand the effectiveness of advertising we
                  serve to you and others, and to deliver relevant advertising
                  to you.
                </li>
                <li>
                  If you are a partner restaurant or merchant or delivery
                  partner, to track the progress of delivery or status of the
                  order placed by our customers.
                </li>
                <li>
                  To carry out academic research with academic partners in an
                  aggregated and anonymized manner.
                </li>
                <li>
                  Administer and facilitate contests, campaigns, giveaways and
                  sweepstakes.
                </li>
                <li>
                  We may combine the information that we receive from third
                  parties with the information you give to us and information we
                  collect about you for the purposes set out above.
                </li>
                <li>
                  Further, we may anonymize and/or de-identify information
                  collected from you through the Services or via other means,
                  including via the use of third-party web analytic tools. As a
                  result, our use and disclosure of aggregated and/or
                  de-identified information is not restricted by this Policy,
                  and it may be used and disclosed to others without limitation.
                </li>
                <li>
                  We analyse the log files of our Platform that may contain
                  Internet Protocol (IP) addresses, browser type and language,
                  Internet service provider (ISP), referring, app crashes, page
                  viewed and exit websites and applications, operating system,
                  date/time stamp, and clickstream data. This helps us to
                  administer the website, to learn about user behavior on the
                  site, to improve our product and services, and to gather
                  demographic information about our user base as a whole.
                </li>
                <li>
                  Notwithstanding above, Google user data collected via the
                  google calendar feature shall not be shared with third parties
                  except for providing Services, improving application
                  functionality and/or to comply with applicable laws.
                </li>
              </ul>
              <h3>DISCLOSURE AND DISTRIBUTION OF YOUR INFORMATION</h3>
              <p>
                We may share your information that we collect for following
                purposes:
              </p>
              <p>
                <strong>With Service Providers:</strong> We may share your
                information with our vendors, consultants, marketing partners,
                research firms and other service providers or business partners,
                such as payment processing companies, for the purposes listed
                above. For example, your information may be shared with outside
                vendors to send you emails and messages or push notifications to
                your devices in relation to our Services, to help us analyze and
                improve the use of our Services, to process and collect
                payments. We also may use vendors for other projects, such as
                conducting surveys or organizing sweepstakes for us.
              </p>
              <p>
                <strong>With Merchant:</strong> While you place a request for
                service through the Platform, your information is provided to us
                and to the Merchants. In order to facilitate your online service
                processing, we provide your information to that Merchant in a
                similar manner as if you had placed an order directly with the
                Merchant. If you provide a mobile phone number, Swiggy may send
                you text messages regarding the service provision status.
              </p>
              <p>
                <strong>With Customer(s):</strong> While Customer requests a
                service through the Platform, Merchant’s information including
                contact number is provided to the Customer if required for
                service fulfilment. In order to facilitate Merchant’s online
                service, we may provide Merchant’s information to the Customer
                in a similar manner as if Customer had placed an order directly
                with the Merchant. Company also reserves the right to use
                information provided by or about the Merchant for the following
                purposes:
              </p>
              <ul style={{ listStyle: "lower-roman" }}>
                <li>Publishing such information on the Platform.</li>
                <li>
                  Contacting Merchants for offering new products or services.
                </li>
                <li>Contacting Merchants for taking product feedback.</li>
                <li>
                  Analyzing software usage patterns for improving product design
                  and utility.
                </li>
                <li>
                  Analyzing anonymized practice information including financial,
                  and inventory information for commercial use.
                </li>
              </ul>
              <p>
                Any personally identifiable information of the Merchants listed
                on the Platform is not generated by Company and is provided to
                Company by Merchants who wish to enlist themselves on the
                Platform, or is collected by Company from the public domain.
                Company displays such information on its Platform on an as-is
                basis making no representation or warranty on the accuracy or
                completeness of the information. As such, we strongly encourage
                Merchants to check the accuracy and completeness of their
                information from time to time, and inform us immediately of any
                discrepancies, changes or updates to such information. Company
                will, however, take reasonable steps to ensure the accuracy and
                completeness of this information.
              </p>
              <p>
                <strong>With Academic Partners:</strong> We may share your
                information with our academic partners for the purpose of
                carrying out academic research in an anonymized and/or
                de-identified manner.
              </p>
              <p>
                <strong>For Crime Prevention or Investigation:</strong> We may
                share this information with governmental agencies or other
                companies assisting us, when we are:
              </p>
              <ul>
                <li>
                  Obligated under the applicable laws or in good faith to
                  respond to court orders and processes; or
                </li>
                <li>
                  Detecting and preventing against actual or potential
                  occurrence of identity theft, fraud, abuse of Services and
                  other illegal acts;
                </li>
                <li>
                  Responding to claims that an advertisement, posting or other
                  content violates the intellectual property rights of a third
                  party;
                </li>
                <li>
                  Under a duty to disclose or share your personal data in order
                  to enforce our Terms of Use and other agreements, policies or
                  to protect the rights, property, or safety of the Company, our
                  customers, or others, or in the event of a claim or dispute
                  relating to your use of our Services.
                </li>
                <li>
                  This includes exchanging information with other companies and
                  organisations for the purposes of fraud detection and credit
                  risk reduction.
                </li>
              </ul>
              <p>
                <strong>For Internal Use:</strong> We may share your information
                with any present or future member of our “Group” (as defined
                below) or affiliates for our internal business purposes. The
                term “Group” means, with respect to any person, any entity that
                is controlled by such person, or any entity that controls such
                person, or any entity that is under common control with such
                person, whether directly or indirectly, or, in the case of a
                natural person, any Relative (as such term is defined in the
                Companies Act, 1956 and Companies Act, 2013 to the extent
                applicable) of such person.
              </p>
              <p>
                <strong>With Advertisers and advertising networks:</strong> We
                may work with third parties such as network advertisers to serve
                advertisements on the Platform and on third-party websites or
                other media (e.g., social networking platforms). These third
                parties may use cookies, JavaScript, web beacons (including
                clear GIFs), Flash LSOs and other tracking technologies to
                measure the effectiveness of their ads and to personalize
                advertising content to you.
              </p>
              <p>
                You cannot opt out of advertising on the Platform, you may opt
                out of much interest-based advertising on third party sites and
                through third party ad networks (including DoubleClick Ad
                Exchange, Facebook Audience Network and Google AdSense). For
                more information, visit www.aboutads.info/choices. Opting out
                means that you will no longer receive personalized ads by third
                parties ad networks from which you have opted out, which is
                based on your browsing information across multiple sites and
                online services. If you delete cookies or change devices, your
                opt out may no longer be effective.To fulfill the purpose for
                which you provide it.
              </p>
              <p>
                We may share your information other than as described in this
                Policy if we notify you and you consent to the sharing.
              </p>
              <h3>CHILDREN'S AND MINOR'S PRIVACY</h3>
              <p>
                Company strongly encourages parents and guardians to supervise
                the online activities of their minor children and consider using
                parental control tools available from online services and
                software manufacturers to help provide a child-friendly online
                environment. These tools also can prevent minors from disclosing
                their name, address, and other personally identifiable
                information online without parental permission. Although the
                Company Platform is not intended for use by minors, Company
                respects the privacy of minors who may inadvertently use the
                internet or the mobile application.
              </p>
              <h3>DATA SECURITY PRECAUTIONS</h3>
              <p>
                We have in place appropriate technical and security measures to
                secure the information collected by us.
              </p>
              <p>
                We use vault and tokenization services from third party service
                providers to protect the sensitive personal information provided
                by you. The third-party service providers with respect to our
                vault and tokenization services and our payment gateway and
                payment processing are compliant with the payment card industry
                standard (generally referred to as PCI compliant service
                providers).
              </p>
              <p>
                You are advised not to send your full credit/debit card details
                through unencrypted electronic platforms. Where we have given
                you (or where you have chosen) a username and password which
                enables you to access certain parts of the Platform, you are
                responsible for keeping these details confidential. We ask you
                not to share your password with anyone.
              </p>
              <p>
                Please be aware that the transmission of information via the
                internet is not completely secure. Although we will do our best
                to protect your personal data, we cannot guarantee the security
                of your data transmitted through the Platform. Once we have
                received your information, we will use strict physical,
                electronic, and procedural safeguards to try to prevent
                unauthorised access.
              </p>
              <p>
                If you suspect any unauthorized use of your account, you must
                immediately notify us by sending an email to the contact details
                indicated in the contact section. You shall be liable to
                indemnify us due to any loss suffered by us due to such
                unauthorized use of your account or password.
              </p>
              <p>
                Under certain circumstances, we shall not be able to take your
                prior consent before disclosing your information in case the
                information is demanded by government agencies or otherwise
                mandated under law to obtain SPDI, or during investigation of
                cyber incidents, prosecution of offenses etc.
              </p>
              <p>
                Further, we shall not be responsible for any breach of security
                or for any actions of any third parties or events that are
                beyond our reasonable control including but not limited to acts
                of government, computer hacking, unauthorised access to computer
                data and storage device, computer crashes, breach of security
                and encryption, poor quality of internet service or telephone
                service of the Merchant, Customer etc.
              </p>
              <p>
                Company may keep records of electronic communications and
                telephone calls received and made for making appointments or
                other purposes for the purpose of administration of Services,
                customer support, research and development and for better
                listing of Merchants.
              </p>
              <p>
                As a Merchant, to the extent you collect SPDI of merchants, you
                agree to comply with your obligations of having in place
                reasonable security measures, in accordance with applicable law.
              </p>
              <h3>OPT-OUT/ WITHDRAWAL OF CONSENT</h3>
              <p>
                When you sign up for an account, you are opting in to receive
                emails from Company. You can log into manage your email
                preferences or you can follow the “unsubscribe” instructions in
                commercial email messages, but note that you cannot opt out of
                receiving certain administrative notices, service notices, or
                legal notices from Company.
              </p>
              <p>
                If you wish to withdraw your consent for the use and disclosure
                of your personal information in the manner provided in this
                Policy or you want your data to be deleted, please write to us
                at
                <strong>_partnersupport@swiggy.in_.</strong> Please note that we
                may take time to process such requests, and your request shall
                take effect no later than 5 (Five) business days from the
                receipt of such request, after which we will not use your
                personal data for any processing unless required by us to comply
                with our legal obligations. We may not be able to offer you any
                or all Services upon such withdrawal of your consent.
              </p>
              <h3>GRIEVANCE OFFICER AND PLATFORM SECURITY</h3>
              <p>
                If you have any queries relating to the processing or usage of
                information provided by you in connection with this Policy,
                please email us at __partnersupport@swiggy.in______or write to
                our Grievance Officer at the following address: Swiggy Grievance
                Officer
                <br /> No.55 Sy No.8-14, Ground Floor, I&J Block, Embassy Tech
                Village, Outer Ring Road, Devarbisanahalli, Bengaluru – 560103
              </p>
              <p>
                If you come across any abuse or violation of the Policy, please
                report to
                <strong>__partnersupport@swiggy.in_.</strong> Further, please
                note that the Platform stores your data with the cloud platform
                of Amazon Web Services provided by Amazon Web Services, Inc.,
                which may store this data on their servers located outside of
                India. Amazon Web Services has security measures in place to
                protect the loss, misuse and alteration of the information,
                details of which are available at https://aws.amazon.com/. The
                privacy policy adopted by Amazon Web Services are detailed in
                https://aws.amazon.com/privacy. In the event you have questions
                or concerns about the security measures adopted by Amazon Web
                Services, you can contact their data protection / privacy team /
                legal team or designated the grievance officer at these
                organisations, whose contact details are available in its
                privacy policy, or can also write to our Grievance Officer at
                the address provided above.
              </p>
              <h3>MISCELLANEOUS</h3>
              <p>
                <strong>Disclaimer:</strong> We cannot ensure that all of your
                Personal Data and SPDI will never be disclosed in ways not
                otherwise described in this Policy. Therefore, although we are
                committed to protecting your privacy, we do not promise, and you
                should not expect, that your information or private
                communications will always remain private. While using the
                Platform or availing any of our Services, you understand and
                agree that you assume all responsibility and risk for your use
                of the Platform, and Internet generally, and the information you
                post or access and for your conduct on and off the Platform.
              </p>
              <p>
                <strong>Indemnity:</strong> You agree and undertake to indemnify
                us in any suit or dispute by any third party arising out of
                disclosure of information by you to third parties either through
                our Platforms or otherwise and your use and access of websites,
                applications and resources of third parties.
              </p>
              <p>
                <strong>Severability:</strong> Each clause of this Policy shall
                be and remain separate from and independent of and severable
                from all and any other clauses herein, except where otherwise
                expressly indicated or indicated by the context of the Policy.
                The decision or declaration that one or more clauses are null
                and void shall have no effect on remaining clauses of this
                Policy.
              </p>
              <p>
                <strong>Limitation of Liability:</strong> The Company shall not
                be liable for any consequential, incidental, special, indirect,
                exemplary or punitive damages, or damages for any loss of
                profits, revenue or business, regardless of the nature of the
                claim, even if the Company has been notified of the possibility
                of such damages.
              </p>
              <p>
                <strong>Governing Law and Jurisdiction:</strong> This Policy
                shall be governed by the laws of India as applicable between
                residents of India without regard to any principles of conflict
                of laws. Subject to the Terms of use, any and all disputes
                arising hereunder shall be subject to the exclusive jurisdiction
                of the courts at Bangalore, India.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default PrivacyPolicy;
